<template>
<el-dialog @close='cancel' title="添加商品" :visible.sync="dialogVisible" width="800px">
    <div class="goodsListDialog add_goods_box">
        <div class="left_menu_box" style="height: 500px;overflow-y: auto;overflow-x: hidden">
            <div class="shop_list" @click="handleClick({catename: ''})">
                <div :class="[activeName==''?'is_select':'']" class="listItem">
                    <span class="el-dropdown-link">全部分类</span>
                </div>
            </div>
            <div class="shop_list" v-for="(obj, index) of categoryList" :key="index" @click="handleClick(obj)">
                <div :class="[activeName==obj.catename?'is_select':'']" class="listItem">
                    <span class="el-dropdown-link">{{obj.catename}}</span>
                </div>
            </div>
        </div>
        <div class="right_main_box">
            <div class="add_goods_search_box">
                <div>
                    <span>已选择<span class="tc-orange">{{selectedResult.length}}</span>个商品</span>
                    <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                </div>
                <el-input placeholder="输入商品名称" v-model="param.productname" clearable></el-input>
                <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
            </div>
            <div class="add_goods_tabs_box">
                <el-table :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange" ref="multipleTable" @row-click="handleRowChange">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="商品信息">
                        <template slot-scope="scope">
                            <div class="goods_item_box">
                                <img class="img" v-lazy="scope.row.coveratturlid" alt>
                                <div class="rightbox">
                                    <div class="text-ellipse">{{scope.row.productname}}</div>
                                    <div class="tc-red">￥{{scope.row.saleprice}}</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page" style="margin-top: 15px; text-align: center">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="page.page"
                    :page-size="page.pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer"  style="margin-top: 20px;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </div>
    </div>
</el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getEventProductList, getEventProductCategoryList, uploadAddProductByEvent, getProviderEventProductList, getProviderEventProductCategoryList, uploadProviderAddProductByEvent} from 'api/brandBusiness'
export default {
    name: 'shop',
    data() {
        return {
            categoryList: [],
            activeName: '',
            param: {
                catecode: '',
                catename: '',
                fromsource: 2,
                hostroletype: 2,
                productname: '',
                rolehostid: '',
                status: ''
            },
            page: {
                page: 1,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            eventid: '',
            hostroletype: 2,
            specproductid: ''
        }
    },
    mounted() {

    },
    methods: {
        handleCheck() {
            this.tableData.forEach(obj => {
                obj.isCheck = false
            })
            this.$refs.multipleTable.clearSelection()
            this.selectedResult = []
        },
        handleSizeChange() {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        openDialog(obj, hostroletype, specproductid) {
            this.tableData = []
            this.dialogVisible = true
            this.eventid = obj.eventid
            this.specproductid = specproductid
            this.hostroletype = hostroletype
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getEventProductCategoryList()
            } else {
                this._getEventProductCategoryList2()
            }
        },
        cancel() {
            this.param.productname = ''
            this.page = {
                page: 1,
                pageSize: 5,
                pageCount: 0
            }
            this.selectedResult = []
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 1
            this.tableData = []
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handleClick(obj) {
            this.activeName = obj.catename
            this.param.catecode = obj.catecode
            this.page.page = 1
            this.tableData = []
            this._getList()
        },
        _getEventProductCategoryList() {
            this.setLoading(true)
            getEventProductCategoryList({
                data: Object.assign({}, {
                    catename: '',
                    page: 1,
                    pageSize: 1000
                }),
                success: data => {
                    this.categoryList = data.data.content
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getEventProductCategoryList2() {
            this.setLoading(true)
            getProviderEventProductCategoryList({
                data: Object.assign({}, {
                    catename: '',
                    page: 1,
                    pageSize: 1000
                }),
                success: data => {
                    this.categoryList = data.data.content
                    this.setLoading(false)
                    this._getList2()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 获取不同类型下商品列表
        _getList() {
            this.setLoading(true)
            getEventProductList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.datalist.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.tableData = data.data.datalist
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj,i) => {
                            this.tableData.forEach((obj2,j) => {
                                if (obj === obj2.productid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable.toggleRowSelection(this.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        // 获取不同类型下商品列表
        _getList2() {
            this.setLoading(true)
            getProviderEventProductList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.datalist.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.tableData = data.data.datalist
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj,i) => {
                            this.tableData.forEach((obj2,j) => {
                                if (obj === obj2.productid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable.toggleRowSelection(this.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        handleSelectionChange(selection, row) {
            row.isCheck = !row.isCheck
            this._changeSelection(row)
        },
        handleRowChange(row) {
            row.isCheck = !row.isCheck
            if (row.isCheck) {
                this.$refs.multipleTable.toggleRowSelection(row)
            } else {
                this.$refs.multipleTable.toggleRowSelection(row, false)
            }
            this._changeSelection(row)
        },
        _changeSelection(row) {
            if (row.isCheck) {
                this.selectedResult.push(row.productid)
            } else {
                this.selectedResult.forEach((obj1, index1) => {
                    if (obj1 === row.productid) {
                        this.selectedResult.splice(index1, 1)
                    }
                })
            }
        },
        // 确定添加商品
        sureAdd() {
            if (!this.selectedResult.length) {
                this.$message.error('请选择商品')
                return false
            }
            let obj = {
                productids: this.selectedResult,
                eventid: this.eventid,
                specproductid: this.specproductid
            }
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._save(obj)
            } else {
                this._save2(obj)
            }
        },
        _save(obj) {
            this.setLoading(true)
            uploadAddProductByEvent({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('添加成功')
                    this.setLoading(false)
                    this.setIsRefresh(2)
                    this.$emit('getList')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _save2(obj) {
            this.setLoading(true)
            uploadProviderAddProductByEvent({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('添加成功')
                    this.setLoading(false)
                    this.setIsRefresh(2)
                    this.$emit('getList2')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goodsListDialog.add_goods_box {
    display: flex;
    .left_menu_box{
        width: 200px;
        min-height: 500px;
        margin-right: 20px;
        border-right: 1px solid #DCDFE6;
        box-sizing: border-box;
        &>div{
            text-align: center;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 150px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(48,49,51,1);
            box-sizing: border-box;
        }
        &>div:hover{
            background:rgba(230,241,252,1);
        }
        .top_box{
            // background:rgba(230,241,252,1);
            border-right: 4px solid transparent;
            text-align: right;
            padding-right: 36px;
            cursor: pointer;
        }
        .shop_list{
            .listItem{
                border-right: 4px solid transparent;
                padding-right: 15px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-right: 15px;
                width: 150px;
            }
            .el-dropdown-link {
                cursor: pointer;
                text-align: center;
            }
            .el-icon--right {
                margin-left: 20px;
            }
            .el-dialog__header{
                display: flex;
                justify-content: space-between;
            }
            .el-dropdown {
                display: flex;
                line-height: 1;
                span{
                    display: inline-block;
                    width: 74px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .is_select{
            background:rgba(230,241,252,1);
            border-right: 4px solid #409EFF !important;
            color:rgba(64,158,255,1);
            .el-dropdown-link{
                color:rgba(64,158,255,1);
            }
        }
    }
    .add_goods_search_box {
        display: flex;
        margin-bottom: 10px;
        width: 100%;
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 36px;
        }
        .el-button,
        .el-button--mini {
            height: 36px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table{
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 42px;
            box-sizing: border-box;
            .img {
                display: block;
                width: 50px;
                min-width: 50px;
                height: 50px;
                margin: 0 20px 0 10px;
            }
            .rightbox{
                display: flex;
                flex-direction: column;
                color:  #303133;
                font-size: 14px;
                width: 480px;
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .right_main_box{
        width: 100%;
    }
    .el-table::before{
        height: 0;
    }
}
</style>
